module.exports = "<div mode=\"mode\"></div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/continue-3ds-redirect/template.html
// module id = ../node_modules/xo-guest-components/src/continue-3ds-redirect/template.html
// module chunks = 0